module.exports = __webpack_public_path__ + "img/5844d3b6ef2b0cf121026b3bac177d9e.png";